import { Service } from '@angular/core';
import { Build } from '@portal-core/builds/models/build.model';
import { BuildsState } from '@portal-core/builds/services/builds-data.service';
import { PageDataServiceBase, PageState, PageStateBase, PageStateService } from '@portal-core/data/page/services/page.state';

@PageState({
  name: 'projectBuildsPageState',
  actionName: 'ProjectBuildsPage'
})
export class ProjectBuildsPageState extends PageStateBase { }

@Service()
@PageStateService<Build>({
  pageState: ProjectBuildsPageState,
  itemCollectionState: BuildsState
})
export class ProjectBuildsPageDataService extends PageDataServiceBase<Build> {
  override state = ProjectBuildsPageState;
}
